import { z } from 'zod';

export function validatePassword(password?: string) {
  const hasOneLowercaseCharacter = password?.match(/[a-z]/) != null;
  const hasOneUppercaseCharacter = password?.match(/[A-Z]/) != null;
  const hasRightLength = password != null && password?.length >= 8 && password?.length < 50;
  const hasOneNumber = password?.match(/\d/) != null;

  const isValid =
    hasOneLowercaseCharacter && hasOneUppercaseCharacter && hasRightLength && hasOneNumber;

  return {
    hasOneLowercaseCharacter,
    hasOneUppercaseCharacter,
    hasRightLength,
    hasOneNumber,
    isValid,
  };
}

export enum PasswordErrors {
  LOWERCASE_CHARACTER = 'LOWERCASE_CHARACTER',
  UPPERCASE_CHARACTER = 'UPPERCASE_CHARACTER',
  LENGTH = 'LENGTH',
  NUMBER = 'NUMBER',
}

export const passwordSchema = z.string().superRefine((value, ctx) => {
  const { hasOneLowercaseCharacter, hasOneUppercaseCharacter, hasRightLength, hasOneNumber } =
    validatePassword(value);

  if (!hasOneLowercaseCharacter) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: PasswordErrors.LOWERCASE_CHARACTER,
    });
  }

  if (!hasOneUppercaseCharacter) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,

      message: PasswordErrors.UPPERCASE_CHARACTER,
    });
  }

  if (!hasRightLength) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,

      message: PasswordErrors.LENGTH,
    });
  }

  if (!hasOneNumber) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: PasswordErrors.NUMBER,
    });
  }
});
